/* K Skin Aura cart bar + drawer refresh.
   - Free delivery milestone: whole basket after codes (Shopify's UK free-delivery rule).
   - Free gift milestone: individual products only (sets excluded), after codes. Rules read live from the BOGOS offer.
   - Store credit line: 5% of the basket after codes, shown in money (Aura Credit).
   - Keeps the cart drawer in sync when an app (BOGOS) changes the cart, and removes the +/- from gift lines. */
(function () {
  if (window.KSACartBar) return;
  var KSA = (window.KSACartBar = {});
  var cartCache = null;

  function heading() { return document.querySelector('[data-ksa-cartbar]'); }
  function money(c) {
    var v = (Math.max(0, c) / 100).toFixed(2);
    return '£' + (v.slice(-3) === '.00' ? v.slice(0, -3) : v);
  }
  // Store credit amount in the cart's currency, always 2 decimals (theme money format, then Intl, then £).
  function creditMoney(c, cart) {
    c = Math.max(0, c);
    try { if (window.theme && theme.Currency && theme.moneyFormat) return theme.Currency.formatMoney(c, theme.moneyFormat); } catch (e) {}
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (cart && cart.currency) || 'GBP' }).format(c / 100); } catch (e) {}
    return '£' + (c / 100).toFixed(2);
  }
  function set(list) { var o = {}; (list || []).forEach(function (k) { if (k !== '' && k != null) o[String(k)] = true; }); return o; }

  // Gift offer rules: BOGOS live data when it has loaded, theme settings until then.
  function rules() {
    var el = heading();
    var r = {
      delivery: +(el && el.dataset.delivery) || 2500,
      gift: +(el && el.dataset.gift) || 6000,
      rate: parseFloat(el && el.dataset.rate) || 0.05,
      excluded: set(((el && el.dataset.excluded) || '').split(',')),
      giftVariants: {},
      giftOn: true,
      live: false
    };
    var fg = window.fgData;
    if (fg && Array.isArray(fg.offers)) {
      r.live = true;
      var now = Date.now();
      var offer = fg.offers.filter(function (o) {
        if (o.deleted_at) return false;
        if (o.start_time && Date.parse(o.start_time) > now) return false;
        if (o.end_time && Date.parse(o.end_time) < now) return false;
        return (o.offer_conditions || []).some(function (c) { return c.unit === 'money' && +c.min_amount > 0; });
      })[0];
      if (!offer) { r.giftOn = false; return r; }
      var cond = offer.offer_conditions.filter(function (c) { return c.unit === 'money'; })[0];
      r.gift = Math.round(+cond.min_amount * 100);
      var ex = {};
      (cond.product_narrow || []).forEach(function (n) { Object.keys(n.value || {}).forEach(function (id) { ex[id] = true; }); });
      if (Object.keys(ex).length) r.excluded = ex;
      (offer.gift_items || []).forEach(function (g) { if (g.variant_shopify_id) r.giftVariants[String(g.variant_shopify_id)] = true; });
    }
    return r;
  }

  function isGift(item, r) {
    return !!(r.giftVariants[String(item.variant_id)] ||
      /sca_clone_freegift/.test(item.handle || item.url || '') ||
      (item.final_line_price === 0 && /^🎁/.test(item.product_title || '')));
  }

  KSA.state = function (cart) {
    var r = rules();
    var items = cart.items || [];
    var paid = items.filter(function (i) { return !isGift(i, r); });
    var total = cart.total_price;
    var ratio = cart.items_subtotal_price > 0 ? total / cart.items_subtotal_price : 1;
    var eligibleLines = paid.filter(function (i) { return !r.excluded[String(i.product_id)]; });
    var eligibleBefore = eligibleLines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var s = {
      empty: cart.item_count === 0,
      total: total,
      eligible: Math.round(eligibleBefore * ratio),
      hasEligible: eligibleLines.length > 0,
      hasExcluded: paid.length > eligibleLines.length,
      giftInCart: items.some(function (i) { return isGift(i, r); }),
      r: r
    };
    s.showGift = r.giftOn && s.hasEligible;
    s.deliveryMet = total >= r.delivery;
    s.giftMet = s.showGift && s.eligible >= r.gift;
    s.credit = Math.round(Math.max(0, total) * r.rate);
    return s;
  };

  function message(s) {
    var r = s.r;
    if (!s.deliveryMet) return 'You’re <b>' + money(r.delivery - s.total) + '</b> away from free delivery.';
    if (!s.showGift) return 'Free delivery unlocked.';
    if (!s.giftMet) {
      var left = money(r.gift - s.eligible);
      return s.hasExcluded
        ? 'Free delivery unlocked. Add <b>' + left + '</b> more in individual skincare for a free full-size gift.'
        : 'Free delivery unlocked. You’re <b>' + left + '</b> away from a free full-size gift.';
    }
    return s.giftInCart
      ? 'Free delivery and your free full-size gift are in your bag.'
      : 'Free delivery and a free full-size gift unlocked. Choose your gift.';
  }

  KSA.render = function (cart) {
    if (!cart || !cart.items) return;
    cartCache = cart;
    var s = KSA.state(cart);
    document.querySelectorAll('[data-ksa-cartbar]').forEach(function (el) {
      el.hidden = s.empty;
      if (s.empty) return;
      var r = s.r, p, d;
      if (s.showGift) {
        var v = s.deliveryMet ? Math.max(r.delivery, s.eligible) : s.total;
        p = Math.min(1, v / r.gift);
        d = Math.min(0.9, r.delivery / r.gift);
      } else {
        p = Math.min(1, s.total / r.delivery);
        d = 1;
      }
      el.classList.toggle('is-delivery-only', !s.showGift);
      el.style.setProperty('--ksa-p', p.toFixed(4));
      el.style.setProperty('--ksa-d', d.toFixed(4));
      var gl = el.querySelector('[data-ksa-label="gift"] small');
      if (gl) gl.textContent = money(r.gift);
      el.querySelector('[data-ksa-stop="delivery"]').classList.toggle('is-done', s.deliveryMet);
      el.querySelector('[data-ksa-stop="gift"]').classList.toggle('is-done', s.giftMet);
      var msg = message(s);
      var m = el.querySelector('[data-ksa-msg]');
      if (m.innerHTML !== msg) m.innerHTML = msg;
      var cl = el.querySelector('[data-ksa-credit]');
      if (cl) {
        cl.innerHTML = s.credit > 0
          ? 'This order earns you <b>' + creditMoney(s.credit, cart) + '</b> in store credit towards your next purchase.'
          : '';
        cl.hidden = !(s.credit > 0);
      }
    });
  };

  // ---- Drawer: keep lines, count and total in sync when something other than the theme changes the cart.
  function drawerSignature() {
    return [].map.call(document.querySelectorAll('.js-mini-cart-content .mini-cart-item'), function (row) {
      var a = row.querySelector('a[href]'), q = row.querySelector('input.change-minicart');
      return (a ? a.getAttribute('href') : '') + '|' + (q ? q.value : '');
    }).join(',');
  }
  function cartSignature(cart) {
    return cart.items.slice(0, 5).map(function (i) { return i.url + '|' + i.quantity; }).join(',');
  }
  function syncDrawer(cart) {
    var money2 = function (c) { return (window.theme && theme.Currency) ? theme.Currency.formatMoney(c, theme.moneyFormat) : money(c); };
    document.querySelectorAll('.js-cart-count').forEach(function (e) { e.textContent = cart.item_count; });
    document.querySelectorAll('.js-cart-total').forEach(function (e) { e.innerHTML = money2(cart.total_price); });
    if (!document.querySelector('.js-mini-cart-content')) return;
    var empty = cart.item_count === 0;
    var drawnEmpty = !document.querySelector('.js-mini-cart-content .mini-cart-item');
    if ((empty && !drawnEmpty) || (!empty && drawerSignature() !== cartSignature(cart))) {
      if (window.theme && theme.miniCart && theme.miniCart.generateCart) theme.miniCart.generateCart();
    }
  }
  function markGiftLines() {
    document.querySelectorAll('.js-mini-cart-content .mini-cart-item').forEach(function (row) {
      var a = row.querySelector('a[href]');
      var gift = a && /sca_clone_freegift/.test(a.getAttribute('href'));
      if (!gift && cartCache) {
        var href = a && a.getAttribute('href');
        var item = cartCache.items.filter(function (i) { return i.url === href; })[0];
        gift = !!(item && isGift(item, rules()));
      }
      row.classList.toggle('ksa-gift-line', !!gift);
      if (gift && !row.querySelector('.ksa-gift-tag')) {
        var meta = row.querySelector('.mini-cart-meta > div');
        if (meta) meta.insertAdjacentHTML('beforeend', '<div><span class="ksa-gift-tag">Free gift</span></div>');
      }
    });
  }

  var timer = null;
  KSA.refresh = function () {
    patchGetCart();
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { KSA.render(cart); syncDrawer(cart); markGiftLines(); })
        .catch(function () {});
    }, 150);
  };

  // Watch finished network requests instead of wrapping fetch/XHR: apps (BOGOS) replace window.fetch
  // after us, so a wrapper can be lost. Resource timing sees every cart change, whoever makes it.
  var MUTATE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (e) {
          return (e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest') && MUTATE.test(e.name);
        })) KSA.refresh();
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  // BOGOS replaces Shopify.getCart and silently drops a call made while another is running
  // (its callback never fires). The theme calls it twice on every add/change/remove
  // (count + drawer lines), so the drawer lines never redraw. Answer dropped calls ourselves.
  function patchGetCart() {
    var S = window.Shopify;
    if (!S || typeof S.getCart !== 'function' || S.getCart.__ksa) return;
    var inner = S.getCart;
    var wrapped = function (cb) {
      var v = window.FGSECOMAPP && window.FGSECOMAPP.variables;
      if (v && v.secomappGetCartRunning && typeof cb === 'function') {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { try { cb(cart); } catch (e) {} });
        return;
      }
      return inner.apply(this, arguments);
    };
    wrapped.__ksa = true;
    S.getCart = wrapped;
  }
  KSA.patchGetCart = patchGetCart;

  function init() {
    patchGetCart();
    // Piggyback on the theme's own cart updates (add to bag, drawer +/-, remove).
    if (window.theme && theme.freeShipping && theme.freeShipping.load && !theme.freeShipping.__ksa) {
      var orig = theme.freeShipping.load;
      theme.freeShipping.load = function (cart) { try { orig(cart); } catch (e) {} KSA.render(cart); };
      theme.freeShipping.__ksa = true;
    }
    var content = document.querySelector('.js-mini-cart-content');
    if (content && 'MutationObserver' in window) new MutationObserver(markGiftLines).observe(content, { childList: true });
    KSA.refresh();
    // Re-render once BOGOS has loaded its offer data (it arrives after the page).
    var tries = 0;
    (function waitForOffer() {
      patchGetCart();
      if (window.fgData && Array.isArray(window.fgData.offers)) { if (cartCache) KSA.render(cartCache); setTimeout(patchGetCart, 1500); return; }
      if (tries++ < 40) setTimeout(waitForOffer, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
